import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Switch } from '../../components/ui/switch';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../components/ui/select';

const categories = ['breakfast', 'lunch', 'dinner', 'snacks', 'beverages'];

export const MenuFormDialog = ({ open, onOpenChange, onSubmit, formData, setFormData, editingItem }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="font-['Manrope']">{editingItem ? 'Edit Menu Item' : 'Add Menu Item'}</DialogTitle>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label htmlFor="name">Item Name</Label>
          <Input id="name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} placeholder="Pancakes" required className="border-stone-300" data-testid="menu-item-name-input" />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Category</Label>
            <Select value={formData.category} onValueChange={(value) => setFormData({...formData, category: value})}>
              <SelectTrigger className="border-stone-300" data-testid="menu-category-select"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-white">
                {categories.map(cat => (<SelectItem key={cat} value={cat} className="capitalize">{cat}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label htmlFor="price">Price (₹)</Label>
            <Input id="price" type="number" min="0" step="0.01" value={formData.price} onChange={(e) => setFormData({...formData, price: e.target.value})} placeholder="0.00" required className="border-stone-300" data-testid="menu-price-input" />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="description">Description</Label>
          <Textarea id="description" value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})} placeholder="Describe the item..." className="border-stone-300 min-h-[80px]" data-testid="menu-description-input" />
        </div>

        <div className="flex items-center justify-between py-2">
          <Label htmlFor="available">Available</Label>
          <Switch id="available" checked={formData.available} onCheckedChange={(checked) => setFormData({...formData, available: checked})} className="data-[state=checked]:bg-emerald-700" data-testid="menu-available-switch" />
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-stone-300">Cancel</Button>
          <Button type="submit" className="bg-sage-700 hover:bg-sage-800 text-white" data-testid="save-menu-item-button">{editingItem ? 'Update' : 'Create'} Item</Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
